import { saveVehicleToBrowserState } from "api/garage/saveVehicleToBrowserState";
import { RootState } from "interfaces/generics.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { Dispatch } from "redux";
import { equalVehicles } from "../../util/vehicle/equal-vehicles";
import { IGetAllVehiclesAction, ISelectVehicleAction } from "../interfaces/garage.interface";
import { getAllVehicles } from "./getAllVehicles";
import { selectVehicle } from "./selectVehicle";

export function waitForGarageAndAddVehicle(vehicleToset: IVehicle, force: any) {
  return (dispatch: Dispatch<ISelectVehicleAction | IGetAllVehiclesAction, RootState>, getState: () => RootState) => {
    const { selectedVehicle, vehicles } = getState().garage;
    if (!force && equalVehicles(selectedVehicle, vehicleToset)) {
      return;
    }
    const newVehicleToSet = { ...vehicleToset };
    // set user engine in vehicle, geting engine from all matching vehicle.
    if ((newVehicleToSet && newVehicleToSet.fitmentOptions.length === 0) && vehicles && equalVehicles(selectedVehicle, newVehicleToSet)) {
      const currentOldVehicle = vehicles.find((vehicleItem) => equalVehicles(vehicleItem, selectedVehicle));
      if (currentOldVehicle) {
        newVehicleToSet.fitmentOptions = currentOldVehicle.fitmentOptions;
      }
    }

    dispatch(selectVehicle(newVehicleToSet, true));

    saveVehicleToBrowserState(newVehicleToSet)
      .then(({ data }: any) => {
        if (data.success) {
          dispatch(getAllVehicles());
        } else if (
          decodeURIComponent(vehicleToset.make) !== vehicleToset.make
            || decodeURIComponent(vehicleToset.model) !== vehicleToset.model
        ) {
          dispatch(waitForGarageAndAddVehicle({
            ...vehicleToset,
            make: decodeURIComponent(vehicleToset.make),
            model: decodeURIComponent(vehicleToset.model),
          }, force));
        }
      });
  };
}
